import { Course } from "../../models/interfaces/course.interface";
import { CourseType } from "../../models/enums/course-type.enum";
import { CourseLocation } from "../../models/enums/course-location.enum";

const TENANT_ID = 'tenant-uuid';
const CATEGORY_TECH = 'category-uuid';
const CATEGORY_GESTAO = 'category-uuid-2';
const CATEGORY_DESIGN = 'category-uuid-3';
const CATEGORY_MARKETING = 'category-uuid-4';
const CATEGORY_DADOS = 'category-uuid-5';
const CATEGORY_FINANCAS = 'category-uuid-7';
const CATEGORY_INOVACAO = 'category-uuid-8';
const COVER_1 = 'assets/mocks/course-1-imageUrl.png';
const COVER_2 = 'assets/mocks/course-2-imageUrl.png';
const COVER_3 = 'assets/mocks/course-3-imageUrl.png';

export const courseMock: Course[] = [
  {
    id: 'course-uuid-1',
    tenantId: TENANT_ID,
    title: 'Angular Avançado',
    description: 'Curso avançado de Angular',
    coverImageUrl: COVER_1,
    categoryId: CATEGORY_TECH,
    trackIds: ['1', '5', '9'],
    type: CourseType.TRAINING,
    location: CourseLocation.ONLINE,
    durationMinutes: 300,
    modulesIds: ['module-1', 'module-2', 'module-3', 'module-4', 'module-5', 'module-6', 'module-7', 'module-8', 'module-9', 'module-10', 'module-11', 'module-12'],
    modules: [],
    
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-2',
    tenantId: TENANT_ID,
    title: 'React Essencial',
    description: 'Curso completo de React para iniciantes',
    coverImageUrl: COVER_2,
    categoryId: CATEGORY_TECH,
    trackIds: ['1', '10'],
    type: CourseType.COURSE,
    location: CourseLocation.PRESENTIAL,
    durationMinutes: 420,
    modulesIds: ['module-1', 'module-2', 'module-3', 'module-4', 'module-5', 'module-6', 'module-7', 'module-8'],
    modules: [],
    
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-3',
    tenantId: TENANT_ID,
    title: 'Node.js para Web',
    description: 'Desenvolvimento backend com Node.js',
    coverImageUrl: COVER_3,
    categoryId: CATEGORY_TECH,
    trackIds: ['1', '5'],
    type: CourseType.TRAINING,
    location: CourseLocation.ONLINE,
    durationMinutes: 360,
    modulesIds: ['module-1', 'module-2', 'module-3', 'module-4', 'module-5', 'module-6', 'module-7', 'module-8', 'module-9', 'module-10'],
    modules: [],
    
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-4',
    tenantId: TENANT_ID,
    title: 'UX/UI Design',
    description: 'Fundamentos de design de interfaces',
    coverImageUrl: COVER_1,
    categoryId: CATEGORY_DESIGN,
    trackIds: ['2', '5', '7'],
    type: CourseType.COURSE,
    location: CourseLocation.PRESENTIAL,
    durationMinutes: 240,
    modulesIds: ['module-1', 'module-2', 'module-3'],
    modules: [],
    
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-5',
    tenantId: TENANT_ID,
    title: 'Python para Data Science',
    description: 'Introdução à análise de dados com Python',
    coverImageUrl: COVER_2,
    categoryId: CATEGORY_DADOS,
    trackIds: ['2', '6'],
    type: CourseType.TRAINING,
    location: CourseLocation.ONLINE,
    durationMinutes: 540,
    modulesIds: ['module-1', 'module-2', 'module-3', 'module-4', 'module-5', 'module-6', 'module-7', 'module-8', 'module-9', 'module-10', 'module-11', 'module-12', 'module-13', 'module-14'],
    modules: [],

    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-6',
    tenantId: TENANT_ID,
    title: 'DevOps na Prática',
    description: 'Automação e integração contínua',
    coverImageUrl: COVER_3,
    categoryId: CATEGORY_TECH,
    trackIds: ['2'],
    type: CourseType.TRAINING,
    location: CourseLocation.ONLINE,
    durationMinutes: 390,
    modulesIds: ['module-1', 'module-2', 'module-3', 'module-4', 'module-5', 'module-6', 'module-7', 'module-8', 'module-9'],
    modules: [],
    
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-7',
    tenantId: TENANT_ID,
    title: 'Banco de Dados SQL',
    description: 'Modelagem e consultas em SQL',
    coverImageUrl: COVER_1,
    categoryId: CATEGORY_DADOS,
    trackIds: ['3', '5', '7'],
    type: CourseType.COURSE,
    location: CourseLocation.PRESENTIAL,
    durationMinutes: 270,
    modulesIds: ['module-1', 'module-2', 'module-3', 'module-4', 'module-5', 'module-6', 'module-7'],
    modules: [],
    
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-8',
    tenantId: TENANT_ID,
    title: 'JavaScript Moderno',
    description: 'ES6+ e boas práticas',
    coverImageUrl: COVER_2,
    categoryId: CATEGORY_TECH,
    trackIds: ['3', '6', '9'],
    type: CourseType.TRAINING,
    location: CourseLocation.ONLINE,
    durationMinutes: 330,
    modulesIds: ['module-1', 'module-2', 'module-3', 'module-4', 'module-5', 'module-6', 'module-7', 'module-8', 'module-9'],
    modules: [],
    
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-9',
    tenantId: TENANT_ID,
    title: 'Gestão de Projetos Ágeis',
    description: 'Scrum, Kanban e metodologias ágeis',
    coverImageUrl: COVER_3,
    categoryId: CATEGORY_GESTAO,
    trackIds: ['3', '6', '8'],
    type: CourseType.COURSE,
    location: CourseLocation.PRESENTIAL,
    durationMinutes: 300,
    modulesIds: ['module-1', 'module-2', 'module-3', 'module-4', 'module-5', 'module-6', 'module-7', 'module-8', 'module-9', 'module-10', 'module-11'],
    modules: [],
    
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-10',
    tenantId: TENANT_ID,
    title: 'Cloud Computing',
    description: 'Conceitos e práticas de computação em nuvem',
    coverImageUrl: COVER_1,
    categoryId: CATEGORY_TECH,
    trackIds: ['4', '5'],
    type: CourseType.TRAINING,
    location: CourseLocation.ONLINE,
    durationMinutes: 360,
    modulesIds: ['module-1', 'module-2', 'module-3', 'module-4', 'module-5', 'module-6', 'module-7', 'module-8', 'module-9'],
    modules: [],
    
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-11',
    tenantId: TENANT_ID,
    title: 'Marketing Digital Essencial',
    description: 'Fundamentos de marketing digital e métricas de campanha',
    coverImageUrl: COVER_2,
    categoryId: CATEGORY_MARKETING,
    trackIds: ['8'],
    type: CourseType.COURSE,
    location: CourseLocation.ONLINE,
    durationMinutes: 210,
    modulesIds: ['module-1', 'module-2', 'module-3'],
    modules: [],
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-12',
    tenantId: TENANT_ID,
    title: 'Educação Financeira Corporativa',
    description: 'Orçamento, fluxo de caixa e decisões financeiras no dia a dia',
    coverImageUrl: COVER_3,
    categoryId: CATEGORY_FINANCAS,
    trackIds: ['7'],
    type: CourseType.TRAINING,
    location: CourseLocation.ONLINE,
    durationMinutes: 180,
    modulesIds: ['module-1', 'module-2', 'module-3'],
    modules: [],
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'course-uuid-po',
    tenantId: TENANT_ID,
    title: 'Fundamentos de Capacitação Corporativa',
    description:
      'Uma jornada prática sobre aprendizagem contínua, engajamento de equipes e melhoria de resultados na organização.',
    coverImageUrl: COVER_1,
    categoryId: CATEGORY_INOVACAO,
    trackIds: ['5'],
    type: CourseType.COURSE,
    location: CourseLocation.ONLINE,
    durationMinutes: 200,
    modulesIds: ['module-po-1', 'module-po-2', 'module-po-3'],
    modules: [],
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
];
